const defaultState = {
  status: 'default',
  data: [],
  code: 500,
  message: '',
  id: '',
};

let response = {};
const SettingPayment_lib = (state = defaultState, action = {}) => {
  switch (action.type) {
    case 'SUCCESS_SETTINGPAYMENT_SISWA':
      response = {
        ...state,
        data: action.data ? action.data : {},
        code: action.code ? action.code : 500,
        status: 'success',
        id: action.id ? action.id : '',
        message: action.message ? action.message : '',
      };

      break;
    case 'LOADING_SETTINGPAYMENT_SISWA':
      response = {
        ...state,
        status: 'loading',
        id: action.id ? action.id : '',
      };
      break;
    case 'ERROR_SETTINGPAYMENT_SISWA':
      response = {
        ...state,
        status: 'error',
        message: action.message ? action.message : '',
        code: action.code ? action.code : 500,
      };
      break;
    default:
      return {
        ...state,
      };
  }

  return response;
};

export default SettingPayment_lib;
